<template>
  <div>
    <p>Please click on the amount you would like to deposit OR Please enter the amount in the box below</p>
    
    <!-- Botones de selección de cantidad -->
    <div class="amount-buttons">
      <button 
        v-for="amt in amounts" 
        :key="amt" 
        :disabled="disabled" 
        @click="selectAmount(amt)"
      >
        {{ amt.toLocaleString() }} {{ currency }}
      </button>
    </div>
    
  </div>

  <div class="amount-section">
      <span>Amount</span>
      <div class="amount">
        <button class="button">{{ currency }}</button>
        <input 
          type="number" 
          :value="modelValue" 
          min="1" 
          step="1" 
          :disabled="disabled"
          @input="handleInput"
        >
      </div>
      
      <div v-if="showError" class="mensaje-error">
        Min: 1 {{ currency }}
      </div>
    </div>
</template>

<script>
export default {
  name: 'AmountSelector',
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    amounts: {
      type: Array,
      default: () => [1, 2, 5, 10, 20, 30, 50, 100, 200, 300, 500, 700, 1000]
    },
    currency: {
      type: String,
      default: 'LSL'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'amount-selected'],
  methods: {
    selectAmount(value) {
      this.$emit('update:modelValue', value);
      this.$emit('amount-selected', value);
    },
    handleInput(event) {
      const value = parseFloat(event.target.value) || null;
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style scoped>
.amount-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px 0;
}

.amount-buttons button {
  background-color: #ff8800;
  color: rgb(0, 0, 0);
  border: none;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}

.amount-buttons button:hover {
  background-color: #cc6b00;
}

.amount-buttons button:disabled {
  background-color: #ffaa66;
  color: #5a5a5a;
  cursor: not-allowed;
  opacity: 0.8;
}

.amount-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  min-width: 275px;
  margin: 0 auto;
}

.amount {
  width: 100%;
  display: flex;
  justify-content: center;
}

input[type="number"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
  width: 100%;
}

.button {
  padding: 10px 20px;
  background-color: #dedede;
  color: rgb(0, 0, 0);
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
}

.mensaje-error {
  margin-top: 6px;
  font-size: 12px;
  color: #cc371b;
}

span {
  color: #505050;
  margin: auto;
}
</style>
